<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <!-- <el-col :lg="5" :xl="5">
                    <el-form-item label="工厂编号" class="EL-Form-Item">
                        <el-select v-model="pagination.fcCode" placeholder="请选择">
                            <el-option v-for="item in factoryList" :key="item.fcId" :label="item.fcCode " :value="item.fcCode"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col> -->
                <el-col :lg="5" :xl="5">
                    <el-form-item label="订单编号" class="EL-Form-Item">
                        <el-input v-model="pagination.orderCode" placeholder="请输入" @change="saveSearch()" clearable>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="pagination.matCode" placeholder="请输入" @change="saveSearch()" clearable>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料描述" class="EL-Form-Item">
                        <el-input v-model="pagination.matName" placeholder="请输入" @change="saveSearch()" clearable>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="交易类型" class="EL-Form-Item">
                        <!-- <el-input v-model="pagination.tranType" placeholder="请输入" @change="saveSearch()">
                        </el-input> -->
						<el-select v-model="pagination.tranType" placeholder="请选择" filterable multiple collapse-tags clearable>
							<el-option v-for="(item,index) in tranTypeList" :key="index" :label="item.key" :value="item.key"></el-option>
						</el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getAuxiMaterialData()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetData()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="箱号" class="EL-Form-Item">
                        <el-input v-model="pagination.boxBarcode" placeholder="请输入" @change="saveSearch()" clearable>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="通道" class="EL-Form-Item">
                        <el-input v-model="pagination.whCode" placeholder="请输入" @change="saveSearch()" clearable>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="库位" class="EL-Form-Item">
                        <el-input v-model="pagination.lcCode" placeholder="请输入" @change="saveSearch()" clearable>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="同步状态" class="EL-Form-Item">
                        <!-- <el-input v-model="pagination.syncFlag" placeholder="请输入" @change="saveSearch()">
                        </el-input> -->
                        <el-select v-model="pagination.syncFlag" placeholder="请选择" clearable="clearable">
                            <el-option label="全部" value="">全部</el-option>
                            <el-option label="已同步" value="1">已同步</el-option>
                            <el-option label="未同步" value="0">未同步</el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="操作人" class="EL-Form-Item">
                        <!-- <el-input v-model="pagination.person" placeholder="请输入" @change="saveSearch()">
                        </el-input> -->
                        <el-select v-model="pagination.person" placeholder="请选择" filterable clearable @change="saveSearch()">
							<el-option v-for="(item,index) in userList" :key="index" :label="item.userName" :value="item.userName"></el-option>
						</el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="操作人工号" class="EL-Form-Item">
                        <el-input v-model="pagination.personNumber" placeholder="请输入" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="pagination.requireDate[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions0"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="pagination.requireDate[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>

            </el-form>
            <el-divider></el-divider>
            <plabel text="回写XA系统报表">
                <el-button v-authority="'BACK_MENU7_M12_B1'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <!-- 展示 -->
            <h-table :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getAuxiMaterialData" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="pagination.total" @selectionChange="selectAll">
                <el-table-column type="selection" align="center">
                </el-table-column>
                <el-table-column label="订单编号" prop="orderCode" align="center">
                </el-table-column>
                <el-table-column label="物料编号" prop="matCode" align="center">
                </el-table-column>
                <el-table-column label="物料描述" prop="matName" align="center">
                </el-table-column>
                <el-table-column label="数量" prop="matQuan" align="center">
                </el-table-column>
                <el-table-column label="交易类型" prop="tranType" align="center">
                </el-table-column>
                <!-- <el-table-column label="交易类型" prop="tranType" align="center" width="200px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.tranType == 'TW'">TW: Transfer Item</div>
                        <div v-if="scope.row.tranType == 'RW'">RW: Receive Transferred Item</div>
                        <div v-if="scope.row.tranType == 'IW'">IW: Issue Transferred Item</div>
                        <div v-if="scope.row.tranType == 'RP'">RP: Receive Purchased Item to Stock</div>
                        <div v-if="scope.row.tranType == 'RD'">RD: Receive Purchased Item to Dock</div>
                        <div v-if="scope.row.tranType == 'RI'">RI: Receive Purchased Item to Inspection</div>
                        <div v-if="scope.row.tranType == 'VR'">VR: Returned Purchased Item</div>
                        <div v-if="scope.row.tranType == 'IS'">IS: Issue Item</div>
                        <div v-if="scope.row.tranType == 'IA'">IA: Adjust Item Quantity</div>
                        <div v-if="scope.row.tranType == 'RM'">RM: Receive Production Item</div>
                        <div v-if="scope.row.tranType == 'IP'">IP: Issue Planned Production Component</div>
                        <div v-if="scope.row.tranType == 'PQ'">PQ: PQ transactions</div>
                        <div v-if="scope.row.tranType == 'SS'">SS: Scrap from stock</div>
                    </template>
                </el-table-column> -->
                <el-table-column label="批次" prop="batchNo" align="center">
                </el-table-column>
                <el-table-column label="移出通道" prop="beforeWhCode" align="center">
                </el-table-column>
                <el-table-column label="移入通道" prop="whCode" align="center">
                </el-table-column>
                <el-table-column label="移出库位" prop="beforeLaCode" align="center">
                </el-table-column>
                <el-table-column label="移入库位" prop="laCode" align="center">
                </el-table-column>
                <el-table-column label="箱号" prop="boxBarcode" align="center">
                </el-table-column>
                <el-table-column label="交易时间" prop="createTime" align="center">
                </el-table-column>
                <el-table-column label="异常次数" prop="errorCount" align="center">
                </el-table-column>
                <el-table-column label="同步状态" prop="syncFlag" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.syncFlag == 0">未同步</span>
                        <span v-if="scope.row.syncFlag == 1">已同步</span>
                    </template>
                </el-table-column>
                <el-table-column label="状态" prop="syncFlag" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.syncFlag == 0 && scope.row.errorCount > 0">待处理</span>
                        <span v-if="scope.row.syncFlag == 0 && scope.row.errorCount == 0 ">同步中</span>
                    </template>
                </el-table-column>
                <el-table-column label="同步时间" prop="syncTime" align="center">
                </el-table-column>
                <el-table-column label="操作人" prop="person" align="center">
                </el-table-column>
                <el-table-column label="操作人工号" prop="personNumber" align="center">
                </el-table-column>
                <!-- <el-table-column label="操作" min-width="220px" fixed="right">
                    <template slot-scope="scope">
                        <el-button class="btn-t-edit" @click="openXaErrorLog(scope.row.wxError)">错误信息</el-button> 
                        <el-button class="btn-t-edit" @click="openXaWhInventoryMessageDialog(scope.row)">XA库存信息</el-button> 
                    </template>
                </el-table-column> -->
                <!-- <el-table-column label="交易类型描述" prop="tranTypeDesc" align="center">
                </el-table-column> -->
            </h-table>

            <!-- 错误信息 -->
            <el-dialog :style="$popups.popups(0.4,0.3)" class="fromDialog" title="错误信息" :close-on-click-modal="false" :visible.sync="errorLogDialog">
                <el-form label-width="80px" style="height:500px">
                    <el-col :lg="24" :xl="24">
                        <el-form-item label="错误信息" prop="errorLog">
                            <el-input v-model="errorLog"/>
                        </el-form-item>
                    </el-col>
                </el-form>
            <!-- <span slot="footer" class="dialog-footer footer-bottom">
                <el-button size="small" type="info" @click="editBoxShow = false">关 闭</el-button>
            </span> -->
            </el-dialog>

            <el-dialog title="XA库位" :visible.sync="XaWhInventoryMessageDialog" class="infoDialog" :close-on-click-modal="false" :show-close="false">
                <h-table :headerCellStyle="headerCellStyle" style="height: 46vh" :data="XaWhInventoryMessageList">
                    <el-table-column label="通道编号" align="center" prop="whCode"></el-table-column>
                    <el-table-column label="物料编号" align="center" prop="matCode"></el-table-column>
                    <el-table-column label="物料描述" align="center" prop="matName"></el-table-column>
                    <el-table-column label="物料数量" align="center" prop="matQuan"></el-table-column>
                    <el-table-column label="物料批次" align="center" prop="batchNo"></el-table-column>
                    <el-table-column label="库位" align="center" prop="lcCode"></el-table-column>
                    <el-table-column label="订单编号" align="center" prop="orderCode"></el-table-column>
                    <el-table-column label="规值" prop="matSpecs" align="center">
                    </el-table-column>
                    <el-table-column label="入库时间" align="center" prop="matCreateTime" :formatter="dateFormat"></el-table-column>
                </h-table>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="closeXaWhInventoryMessageDialog" type="info">取 消</el-button>
                </div>
            </el-dialog>
        </box>
    </div>
</template>

<script>
    import moment from "moment";
    export default {
        name: "SriteXa",
        data() {
            return {
                headerCellStyle: () => {
                    return "background-color: #1f5cec";
                },
                form: {},
                //主数据
                mainData: [],
                pagination: {
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                    fcCode: localStorage.getItem("fcCode"),
                    orderCode: "",
                    matCode: "",
                    matName:"",
                    tranType: "",
                    syncFlag: "",
                    person: "",
                    personNumber: "",
                    lcCode: "",
                    whCode: "",
                    boxBarcode: "",
                    auxiFlag: "",
                    requireDate: []
                },

                factoryList: [],

                downloadLoading: false, //下载中

                checkList: [],

                userList: [],

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,

				tranTypeList: [
					{key:'TW',value:'TW: Transfer Item'},
					{key:'RW',value:'RW: Receive Transferred Item'},
					{key:'IW',value:'IW: Issue Transferred Item'},
					{key:'RP',value:'RP: Receive Purchased Item to Stock'},
					{key:'RD',value:'RD: Receive Purchased Item to Dock'},
					{key:'RI',value:'RI: Receive Purchased Item to Inspection'},
					{key:'VR',value:'VR: Returned Purchased Item'},
					{key:'IS',value:'IS: Issue Item'},
					{key:'IA',value:'IA: Adjust Item Quantity'},
					{key:'RM',value:'RM: Receive Production Item'},
					{key:'IP',value:'IP: Issue Planned Production Component'},
					{key:'PQ',value:'PQ: PQ transactions'},
					{key:'SS',value:'SS: Scrap from stock'},
				],
                errorLogDialog: false,
                errorLog: "",   //错误日志信息显示

                //XA库存窗口
                XaWhInventoryMessageDialog: false,
                //XA库存数据
                XaWhInventoryMessageList:[],
            };
        },
        watch: {
            pagination: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getAuxiMaterialData(newVal);
                    }, 1000)
                },
                deep: true,
            },
        },
        computed: {
            pickerOptions() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.pagination.requireDate[0]) {
                            return time.getTime() < new Date(_this.pagination.requireDate[0]);
                        }
                    }
                }
            },
            pickerOptions0() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.pagination.requireDate[1]) {
                            return time.getTime() > new Date(_this.pagination.requireDate[1]);
                        }
                    }
                }
            },
        },
        methods: {
            // 打开XA回写错误信息窗口
            openXaErrorLog(errorLog){
                this.errorLog = errorLog;
                this.errorLogDialog = true;
            },
            // 时间转换
            dateFormat(row, column) {
                var date = row[column.property];
                if (date == undefined) {
                    return "";
                }
                return moment(date).format("YYYY-MM-DD");
            },
            // 获取所有的用户
            getUserAll() {
                this.$http
                    .request({
                        url: "/api/user/userAll",
                        method: "GET",
                        params: {},
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.userList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            // 确认完成
            confirmCompletion(){
                if (this.checkList.length != 1) {
                    this.$message({
                        message: "请选择一条未同步的交易记录再确认完成！",
                        type: "warning",
                    });
                    return false;
                }else{
                    this.$confirm("是否确认此交易记录已经完成?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/writeXa/confirmCompletion",
                                method: "POST",
                                params: {
                                    wxId: this.checkList[0].wxId
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        type: "success",
                                        message: "操作成功",
                                    });
                                }else{
                                    this.$message({
                                        type: "success",
                                        message: "操作失败",
                                    });    
                                }
                                this.getAuxiMaterialData();
                            })
                            .catch((error) => {
                                this.loading++;
                            });    
                    })
                    .catch(() => {
                        this.insertStockReturnMats = false;
                        this.$message({
                            type: "info",
                            message: "已取消退料",
                        });
                    });    
                }  
            },
            // 打开XA交易窗口
            openXaWhInventoryMessageDialog(item){
                this.getXaWhInventoryMessage(item);
            },
            // 关闭XA交易窗口
            closeXaWhInventoryMessageDialog(){
                this.XaWhInventoryMessageDialog = false;
                this.XaWhInventoryMessageList = [];
            },
            // 获取XA交易库存信息
            getXaWhInventoryMessage(item){
                this.$http
                    .request({
                        url: "/api/writeXa/getXaWhInventoryMessage",
                        method: "GET",
                        showLoading: true,
                        params: {
                            batchNo: item.batchNo,
                            laCode: item.laCode,
                            fcCode: localStorage.getItem("fcCode"),
                            item: item.matCode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.XaWhInventoryMessageList = resp.data.list || [];
                            this.XaWhInventoryMessageDialog = true;
                        }else{
                            this.$message({
                                type: "error",
                                message: "操作失败",
                            });    
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });    
            },
            //禁选
            checkboxSelect(row, rowIndex) {
                if (row.syncFlag == 0) {
                    return true; // 禁用
                } else {
                    return false; // 不禁用
                }
            },
            //全选
            selectAll(val) {
                this.checkList = val;
            },
            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy)
                window.lazy = window.setTimeout(() => {
                    this.getAuxiMaterialData()
                }, 1000)
            },
            //获取数据
            getAuxiMaterialData() {
                this.$http
                    .request({
                        url: "/api/writeXa/getWriteXaList",
                        method: "GET",
                        params: {
                            pageNum: this.pagination.pageNum || null,
                            pageSize: this.pagination.pageSize || null,
                            fcCode: this.pagination.fcCode || null,
                            orderCode: this.pagination.orderCode || null,
                            matCode: this.pagination.matCode || null,
                            tranType: this.pagination.tranType?this.pagination.tranType.join(","):null,
                            syncFlag: this.pagination.syncFlag || null,
                            person: this.pagination.person || null,
                            personNumber: this.pagination.personNumber || null,
                            lcCode: this.pagination.lcCode || null,
                            whCode: this.pagination.whCode || null,
                            boxBarcode: this.pagination.boxBarcode || null,
                            auxiFlag: this.pagination.auxiFlag || null,
                            beginTime: this.pagination.requireDate[0] || null,
                            endTime: this.pagination.requireDate[1] || null,
                            matName: this.pagination.matName || null,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.mainData = resp.data.list || [];
                            this.pagination.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            //获取工厂数据
            getFactoryAll() {
                this.$http
                    .request({
                        url: "/api/factory/getFactoryAll",
                        method: "GET",
                        params: {},
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.factoryList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            //重置
            resetData() {
                this.pagination = {
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                    fcCode: localStorage.getItem("fcCode"),
                    orderCode: "",
                    matCode: "",
                    matName:"",
                    tranType: "",
                    syncFlag: "",
                    person: "",
                    personNumber: "",
                    lcCode: "",
                    whCode: "",
                    auxiFlag: "",
                    requireDate: []
                },
                this.getAuxiMaterialData();
            },
            //重新发送
            resend() {
                let hint = ""
                if (this.checkList.length == 0) {
                    hint = "未选择记录则确认重新发送最近一个月数据记录, 是否继续?"
                } else {
                    hint = "选择记录确认重新发送, 是否继续?"
                }
                this.$confirm(hint, "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/writeXa/updateResend",
                                method: "POST",
                                showLoading: true,
                                data: this.checkList,
                                params: {
                                    person: localStorage.getItem("user"),
                                    personNumber: localStorage.getItem("empNumber")
                                }
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "writeXa：重新发送操作成功";
                                } else {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "writeXa：重新发送操作失败";
                                }
                                this.systemLog();
                            })
                            .catch((error) => {
                                this.loading++;
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除",
                        });
                    });
            },

            //表格导出
            downLoadFile() {
                this.downloadLoading = true;
                var paramsObj = {
                    fcCode: this.pagination.fcCode || null,
                    orderCode: this.pagination.orderCode || null,
                    matCode: this.pagination.matCode || null,
                    tranType: this.pagination.tranType?this.pagination.tranType.join(","):null,
                    syncFlag: this.pagination.syncFlag || null,
                    person: this.pagination.person || null,
                    personNumber: this.pagination.personNumber || null,
                    lcCode: this.pagination.lcCode || null,
                    whCode: this.pagination.whCode || null,
                    boxBarcode: this.pagination.boxBarcode || null,
                    auxiFlag: this.pagination.auxiFlag || null,
                    beginTime: this.pagination.requireDate[0] || null,
                    endTime: this.pagination.requireDate[1] || null,
                    matName: this.pagination.matName || null,
                    pageNum: 1,
                    pageSize: 999999,
                }

                this.$http.request({
                    url: '/api/writeXa/getWriteXaList',
                    method: 'GET',
                    showLoading: true,
                    params: paramsObj
                }).then((resp) => {
                    if(resp.data.total != 0){
                        resp.data.list.forEach((item)=>{
                            item.syncStatus = "";
                        })
                    }
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                    list.forEach(function(c) {

                        if(c.syncFlag == 0 && c.errorCount > 0){
                            c['syncStatus'] = '待处理'
                        } else if(c.syncFlag == 0 && c.errorCount == 0){
                            c['syncStatus'] = '同步中'
                        }

                        if (c.syncFlag == 0) {
                            c['syncFlag'] = '未同步'
                        } else if (c.syncFlag == 1) {
                            c['syncFlag'] = '已同步'
                        }

                        // if (c.tranType == "TW") {
                        //     c['tranType'] = 'TW: Transfer Item'
                        // } else if (c.tranType == "RW") {
                        //     c['tranType'] = 'RW: Receive Transferred Item'
                        // } else if (c.tranType == "IW") {
                        //     c['tranType'] = 'IW: Issue Transferred Item'
                        // } else if (c.tranType == "RP") {
                        //     c['tranType'] = 'RP: Receive Purchased Item to Stock'
                        // } else if (c.tranType == "RD") {
                        //     c['tranType'] = 'RD: Receive Purchased Item to Dock'
                        // } else if (c.tranType == "RI") {
                        //     c['tranType'] = 'RI: Receive Purchased Item to Inspection'
                        // } else if (c.tranType == "VR") {
                        //     c['tranType'] = 'VR: Returned Purchased Item'
                        // } else if (c.tranType == "IS") {
                        //     c['tranType'] = 'IS: Issue Item'
                        // } else if (c.tranType == "IA") {
                        //     c['tranType'] = 'IA: Adjust Item Quantity'
                        // } else if (c.tranType == "RM") {
                        //     c['tranType'] = 'RM: Receive Production Item'
                        // } else if (c.tranType == "IP") {
                        //     c['tranType'] = 'IP: Issue Planned Production Component'
                        // } else if (c.tranType == "PQ") {
                        //     c['tranType'] = 'PQ: PQ transactions'
                        // } else if (c.tranType == "SS") {
                        //     c['tranType'] = 'SS: Scrap from stock'
                        // }
                        
                    })
                    const tHeader = ["订单编号","物料编号","数量","交易类型","批次","移出通道","移入通道","移出库位","移入库位","箱号","交易时间","异常次数","同步状态","状态","同步时间","操作人",'操作人工号']
                    const filterVal = ["orderCode","matCode","matQuan","tranType","batchNo","beforeWhCode","whCode","beforeLaCode","laCode","boxBarcode","createTime","errorCount","syncFlag","syncStatus","syncTime","person",'personNumber']
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '回写XA系统报表数据'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "sys_warehouse：导出回写XA系统报表数据"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },

            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "回写XA系统报表",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },

        },
        activated(){
            this.getFactoryAll();
            /* 获取首页的数据 */
            this.getAuxiMaterialData();
            // 获取所有用户
            this.getUserAll();
        },
    };
</script>

<style scoped>
</style>